import '../../styles/Logo.css'
import React from "react";


// MUCH PROPS To this svg to react component converter => https://react-svgr.com/playground/


const Logo = (props) => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    // width="360mm"
    // height="168mm"
    viewBox="-30 -5 210 56"
  >
    <g
      id="logo-content"
      style={{
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }}
    >
      <path
        d="M472 662V158l-31-95-31-31.5L346 0h-62l-64 31.5L189 63l-31 95v62"
        pathLength="360"
        transform="matrix(.01693 0 0 -.01693 27.318 24.06)"
      />
      <path
        d="m346 441-62-31-64-64-31-94v-63l31-94.5 64-63L346 0h95l63 31.5 63 63 31 94.5v63l-31 94-63 64-63 31h-95"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 35.853 24.06)"
      />
      <path
        d="M220 662V0m0 315 95 95 63 31h94l64-31 31-95V0"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 45.979 24.06)"
      />
      <path
        d="M220 441V0m0 315 95 95 63 31h94l64-31 31-95V0"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 56.105 24.06)"
      />
      <path
        d="M346 662V0M126 662h441"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 72.632 24.06)"
      />
      <path
        d="M189 252h378v63l-31 63-32 32-63 31h-95l-62-31-64-64-31-94v-63l31-94.5 64-63L346 0h95l63 31.5 63 63"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 81.166 24.06)"
      />
      <path
        d="M252 662V126l32-94.5L346 0h64M158 441h220"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 90.767 24.06)"
      />
      <path
        d="M252 662V126l32-94.5L346 0h64M158 441h220"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 97.168 24.06)"
      />
      <path
        d="m189 662 31-32 32 32-32 31-31-31m31-221V0"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 103.569 24.06)"
      />
      <path
        d="m536 346-32 64-94 31h-95l-95-31-31-64 31-62 64-32 157-32 63-31 32-63V94.5l-32-63L410 0h-95l-95 31.5-31 63"
        pathLength="360"
        transform="matrix(.017 0 0 -.017 107.836 24.06)"
      />
    </g>
  </svg>
)




export default Logo;

  
  
  